import { Customer } from "../domain/customer/Customer";

const fireCustomerOpenEvent = (customer: Customer) => {
    const event = document.createEvent('Event') as any;
    event.data = JSON.stringify(customer);
    event.initEvent('customer_open', true, true);
    document.body.dispatchEvent(event);
}

export default fireCustomerOpenEvent;
